import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";

@Injectable()
export class DzongkhaService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
    let variables = {};
    console.log("obj", obj);

    if (obj) {
      variables = {
        first: obj.paginationData.pageSize || 10, // Default to 10 if pageSize is not provided
        after: obj.paginationData.after
          ? obj.paginationData.after.endCursor
          : null, // Use null if no cursor is provided
        searchParam: obj.searchParam || null, // Use null if no searchParam is provided
      };
    }
    return this.apollo.watchQuery({
      query: gql`
        query getDzongkhas($first: Int, $after: String, $searchParam: String) {
          dzongkhas(first: $first, after: $after, searchParam: $searchParam) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                dzongkha
                english
              }
              cursor
            }
            totalCount
          }
        }
      `,
      variables,
      errorPolicy: "all",
    }).valueChanges;
  }

  read(id: string) {
    return this.apollo.watchQuery({
      query: gql`
          {
            dzongkha(id: "${id}") {
              id
              dzongkha
              english
            }
          }
        `,
    }).valueChanges;
  }

  create(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation createDzongkha($dzongkha: String!, $english: String!) {
          createDzongkha(dzongkha: { dzongkha: $dzongkha, english: $english }) {
            id
            dzongkha
            english
          }
        }
      `,
      variables: {
        dzongkha: obj.dzongkha,
        english: obj.english,
      },
    });
  }

  update(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateDzongkha(
          $id: String!
          $dzongkha: String!
          $english: String!
        ) {
          updateDzongkha(
            dzongkha: { id: $id, dzongkha: $dzongkha, english: $english }
          ) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
        dzongkha: obj.dzongkha,
        english: obj.english,
      },
    });
  }

  delete(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation removeDzongkha {
          removeDzongkha(dzongkha: {id: "${obj.id}"}) {
            success
          }
        }
      `,
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/dzongkha.service.ts